import * as angular from "angular";
import * as moment from "moment";
import HolidaysServiceName, {HolidaysService} from "../../services/holidays/holidays.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import {Strings} from "../../shared/config/constant.module";
import template from './addHoliday.tpl.html';

let requires = [HolidaysServiceName, NotifyServiceName];

export interface AddHolidayData {
  year: number;
}

export interface AddHolidayController {
  year: number;
  minDate: string;
  maxDate: string;
  date: Date;
  name: string;
  submit(): any;
  cancel(): any;
  form: angular.IFormController;
}

export function openAddHoliday(data: AddHolidayData,
                               $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AddHolidayCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.addHoliday', requires)
  .controller('AddHolidayCtrl', addHolidayCtrl)
  .name;

function addHolidayCtrl(
  data: AddHolidayData,
  $modalInstance,
  holidaysService: HolidaysService,
  notifyService: NotifyService
) {
  'use strict';
  let vm = <AddHolidayController>this;

  vm.year = data.year;
  vm.minDate = moment([data.year, 0, 1]).format(Strings.ISO_DATE_FORMAT);
  vm.maxDate = moment([data.year + 1, 0, 1]).subtract(1, 'days').format(Strings.ISO_DATE_FORMAT);

  vm.submit = function () {
    if (vm.form.$invalid) {
      return;
    }

    let command = {
      date: vm.date,
      name: vm.name
    };

    // call the service
    holidaysService.addHoliday(command)
      .then(function() {
        $modalInstance.close();
      }, notifyService.handleApiErrors);
  };

  vm.cancel = function () {
    $modalInstance.close();
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/holidays/addHoliday.controller.ts